module.exports = {"blocks":[{"type":"sections/sg/contact","prefix":"contact"}],"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1VJ0VDNm2CgDowAWCmi7Y37MJSpE7OstCF1XW9h-lFhE","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"},"dropdown":["General Enquiries & Feedback","Corporate Sales","Marketing & Partnerships","Media Enquiries","Others"]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/sg/setting/contact/setting.json
// module id = 700
// module chunks = 0 1 2 3 4 5